import * as React from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepButton from "@mui/material/StepButton";
import { AppBar, Container, IconButton, StepIconProps, Toolbar } from "@mui/material";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import { useState } from "react";

const steps = ["Excel Upload", "Integration"];

export interface ProgressBarPropsTypes {
  handleStepIconClick: (stepNumber: number) => void;
  currentStep: number;
  optional?: string | null;
  completed: { [k: number]: boolean };
  setCompleted: React.Dispatch<
    React.SetStateAction<{
      [k: number]: boolean;
    }>
  >;
  parentHandleStepIconClick?: (stepNumber: number) => void;
  showBack?:boolean
}

export default function DataUploadStepper(props: ProgressBarPropsTypes) {
  const {
    completed,
    setCompleted,
    currentStep,
    handleStepIconClick,
    optional,
    parentHandleStepIconClick,
    showBack
  } = props;

  // Set the initial completed state on mount
  React.useEffect(() => {
    setCompleted((prev) => ({
      ...prev,
      0: true, // Ensure step 0 is always marked as completed
    }));
  }, [setCompleted]);

  const [activeStep, setActiveStep] = React.useState(currentStep || 0);

  React.useEffect(() => {
    setActiveStep(currentStep || 0); // Sync with currentStep prop
  }, [currentStep]);

  const handleStep = (step: number) => () => {
    // Allow navigation between steps
    handleStepIconClick(step); // Trigger the parent handler
    setActiveStep(step); // Update activeStep state
  };

  const stepperStyles = {
    "& .MuiStepIcon-root": {
      fontSize: 26,
      color: "#909090",
    },
    "& .Mui-active .MuiStepConnector-line": {
      borderColor: "#909090",
    },
    "& .Mui-active .MuiStepIcon-root": {
      color: "#227C9D",
    },
    "& .Mui-completed .MuiStepConnector-line": {
      borderColor: "#23c6b0",
    },
    "& .MuiStepConnector-line": {
      borderColor: "#eaeaf0",
    },
  };

  return (
    <AppBar
      position="static"
      sx={{
        backgroundColor: "#ffffff",
        minHeight: "60px",
        width: "24vw",
        boxShadow: "none",
      }}
    >
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Box sx={{ width: "100%" }}>
            <div style={{display:"flex",gap:"15px"}}>
              {showBack && <IconButton
                color="primary"
                size="small"
                sx={{ fontSize: "1rem", border: "2px solid #1C7EA0" }}
                onClick={() => { parentHandleStepIconClick!(2) }}
              >
                <ArrowBackOutlinedIcon fontSize="small" />
              </IconButton>}
              <Stepper
                nonLinear
                activeStep={activeStep}
                style={{ width: "100%" }}
                sx={stepperStyles}
              >
                {steps.map((label, index) => (
                  <Step key={label}>
                    <StepButton
                      color="inherit"
                      onClick={handleStep(index)}
                    >
                      {label}
                    </StepButton>
                  </Step>
                ))}
              </Stepper>
            </div>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}

